import React, { useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { isAuthenticated as isAuthenticatedFn } from '../../services/auth/api';

interface Props {
  children: React.ReactElement;
}

const PublicRoute = ({ children }: Props) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useLayoutEffect(() => {
    async function effect() {
      const auth = await isAuthenticatedFn();
      if (auth) {
        navigate('/', { replace: true });
        return;
      }
      setIsLoading(false);
    }

    effect();
  }, [navigate]);

  if (isLoading) {
    return null;
  }

  return children;
};

export default PublicRoute;
